(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ff-room-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ff-room-shop')) {
  class FFRoomShop extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;

      this.abortController = new AbortController();
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

      if (!this.tabs.length || !this.panels.length) return;

      const signal = this.abortController.signal;

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(tab, false, true), { signal });
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index), { signal });
      });

      this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event), { signal });

      const selectedTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];
      this.activate(selectedTab, false, false);
      this.dataset.enhanced = 'true';
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
    }

    activate(nextTab, moveFocus = true, scrollTab = true) {
      if (!nextTab) return;

      const controlledPanelId = nextTab.getAttribute('aria-controls');

      this.tabs.forEach((tab) => {
        const isActive = tab === nextTab;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.toggleAttribute('hidden', panel.id !== controlledPanelId);
      });

      if (moveFocus) nextTab.focus({ preventScroll: true });

      if (scrollTab) {
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        nextTab.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    }

    onKeydown(event, currentIndex) {
      let nextIndex;

      switch (event.key) {
        case 'ArrowRight':
          nextIndex = (currentIndex + 1) % this.tabs.length;
          break;
        case 'ArrowLeft':
          nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
          break;
        case 'Home':
          nextIndex = 0;
          break;
        case 'End':
          nextIndex = this.tabs.length - 1;
          break;
        default:
          return;
      }

      event.preventDefault();
      this.activate(this.tabs[nextIndex]);
    }

    onBlockSelect(event) {
      const blockId = event.detail?.blockId;
      const selectedTab = this.tabs.find((tab) => tab.dataset.blockId === blockId);
      if (selectedTab) this.activate(selectedTab, false, true);
    }
  }

  customElements.define('ff-room-shop', FFRoomShop);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ff-studio-discovery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ff-studio-carousel')) {
    class FFStudioCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-studio-track]');
        this.previousButton = this.querySelector('[data-studio-previous]');
        this.nextButton = this.querySelector('[data-studio-next]');

        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.scrollFrame = null;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handlePrevious = () => this.move(-1);
        this.handleNext = () => this.move(1);
        this.handleScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = null;
            this.updateButtons();
          });
        };
        this.handleResize = () => this.updateButtons();

        this.previousButton.addEventListener('click', this.handlePrevious);
        this.nextButton.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize);
        this.updateButtons();
      }

      disconnectedCallback() {
        if (!this.track || !this.previousButton || !this.nextButton) return;

        this.previousButton.removeEventListener('click', this.handlePrevious);
        this.nextButton.removeEventListener('click', this.handleNext);
        this.track.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);

        if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      }

      move(direction) {
        const firstItem = this.track.querySelector('.ff-studio-rooms__item');
        if (!firstItem) return;

        const styles = window.getComputedStyle(this.track);
        const gap = Number.parseFloat(styles.columnGap) || 0;
        const distance = firstItem.getBoundingClientRect().width + gap;

        this.track.scrollBy({
          left: distance * direction,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
        });
      }

      updateButtons() {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const position = Math.abs(this.track.scrollLeft);

        this.previousButton.disabled = position <= 1;
        this.nextButton.disabled = position >= maximum - 1;
      }
    }

    customElements.define('ff-studio-carousel', FFStudioCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerResizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerResizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      const headerHeight = this.header.offsetHeight;
      if (this.lastHeaderHeight === headerHeight) return;
      this.lastHeaderHeight = headerHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    disconnectedCallback() {
      this.headerResizeObserver?.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
